import { isEmpty } from 'lodash'
import Vue from 'vue'
//
// User 정의 영역
//
// http get 처리용
const userParam = (context, params) => {
  return params
}

// http post 처리용
const userBody = (context, body) => {
  return body
}

// http request intercepter 처리용
const userRequestIntercepter = (request) => {
  let promoStore = window.vue.getStore('promoInfo')
  let rootStore = window.vue.getStore('root')

  if (Vue.prototype.$mmpLoading) {
    Vue.prototype.$mmpLoading.show()
  }

  let promoHeader = {
  }

  if (!isEmpty(rootStore.getters.getAppId)) {
    promoHeader['appId'] = rootStore.getters.getAppId
  }

  if (!isEmpty(promoStore.state.promoInfo.coGroupCode)) {
    promoHeader['MC-Co-Group'] = promoStore.state.promoInfo.coGroupCode
  }

  if (!isEmpty(promoStore.state.promoInfo.eduGroupCode)) {
    promoHeader['MC-Edu-Group'] = promoStore.state.promoInfo.eduGroupCode
  }

  request.headers = Object.assign({}, request.headers, promoHeader)

  return request
}

// http response intercepter 처리용
const userResponseIntercepter = (response) => {
  if (Vue.prototype.$mmpLoading) {
    Vue.prototype.$mmpLoading.hide()
  }

  if (response && response.data && response.data.status === 'ERROR' && response.data.code) {
    switch (response.data.code) {
      case 'AUTHENTICATION_NOT_EXIST':
      case 'AUTHENTICATION_FAILED':
      case 'TOKEN_NOT_EXIST_IN_HEADER':
        /* 로그인 후 현재 페이지로 다시 돌아오기 위해 localStorage 에 저장. 2019.10.21 */
        // localStorage.setItem('beforeRouterName', window.vue.getInstance('router').history.current.name)
        // localStorage.setItem('beforeRouterParam', JSON.stringify(window.vue.getInstance('router').history.current.params))
        window.vue.getInstance('router').replace({name: 'LoginError', params: {code: response.data.code}})
        break
      default:
        break
    }
  }

  return response
}

// http error intercepter 처리용
const userErrorIntercepter = (error) => {
  if (Vue.prototype.$mmpLoading) {
    Vue.prototype.$mmpLoading.hide()
  }
  if (error.message === 'Network Error' && window.vue.getStore('root').getters.getAppState === 'RUN') {
    window.vue.getInstance('router').push({'name': 'NetworkError'})
  }
  return error
}

export default {userParam, userBody, userRequestIntercepter, userResponseIntercepter, userErrorIntercepter}



// WEBPACK FOOTER //
// ./src/config/network/handler.js